import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

import {always} from 'ramda';

/** Inclusive upper bounds (in percent) of the four level bands, from the design review. */
const RED_BAND_UPPER_BOUND = 25;
const ORANGE_BAND_UPPER_BOUND = 50;
const YELLOW_BAND_UPPER_BOUND = 75;

/**
 * Theme colour of the filled part of a fuel tank or a battery, picked from the
 * percentage of the range that is filled.
 */
export function getLevelBandColor(percent: number): ThemeColorPath {
  return match(percent)
    .when((value) => value <= RED_BAND_UPPER_BOUND, always<ThemeColorPath>('palettes.red.60.100'))
    .when(
      (value) => value <= ORANGE_BAND_UPPER_BOUND,
      always<ThemeColorPath>('palettes.orange.60.100')
    )
    .when(
      (value) => value <= YELLOW_BAND_UPPER_BOUND,
      always<ThemeColorPath>('palettes.yellow.80.100')
    )
    .otherwise(always<ThemeColorPath>('palettes.green.60.100'));
}
